import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import iconProfilePicture from "../assets/iconProfilePicture.png";
import { useAlertContext } from '../../context/alertContext';


function Comment(props) {
  const [user, setUser] = useState([]);
  const { id } = useParams();
  const [comment, setComment] = useState([]);
  const [getComment, setGetComment] = useState([]);
  const [getNestComment, setGetNestedComment] = useState([]);
  const { showAlert } = useAlertContext()


  const handleChangeComment = (event) => {
    setComment(event.target.value);
  };

  //---------------------- get real date & time

  let objectDate = new Date();
  let day = objectDate.getDate();
  let month = objectDate.getMonth();
  let currMonth = month + 1
  let year = objectDate.getFullYear();
  var currentTimeDate = new Date();
  var hours = currentTimeDate.getHours();
  var minutes = currentTimeDate.getMinutes();
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var AMPM = hours >= 12 ? 'PM' : 'AM';
  if (hours === 12) {
    hours = 12;
  } else {
    hours = hours % 12;
  }
  var time = `${hours}:${minutes}${AMPM}`

  //---------------------- get user data

  useEffect(() => {
    const URL = "https://tbc-backend.up.railway.app/user/getByEmail/";

    axios
      .get(URL + props.email)
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.email]);

  //------------------------------ post comment data
  const [commentHeading, setCommentHeadiner] = useState(false);

  const handleSubmitComment = (event) => {
    event.preventDefault();
    const commentUrl = "https://tbc-backend.up.railway.app/comment/create";
    const headers = { "Content-Type": "application/json" };
    const commentData = {
      authorName: user.firstName + " " + user.lastName,
      authorCurrentField: user.currentField,
      authorNiche: user.niche,
      pitchComments: comment,
      pitchId: id,
      commentDate: day + '/' + currMonth + '/' + year,
      commentTime: time,
    };

    axios
      .post(commentUrl, commentData, { headers })
      .then((res) => {
        showAlert(`Comment is Posted`, 'primary', '#info-fill')
        setComment([]);
        setCommentHeadiner(true)
      })
      .catch((err) => {
        showAlert(`Sorry! Comment is Failed to Post, Try Again`, 'warning', '#exclamation-triangle-fill')

        console.log(err);
      });
  };

  //------------------------------ get comment data

  const commentURL = "https://tbc-backend.up.railway.app/comment/get";

  const WAIT_TIME = 1000;

  useEffect(() => {
    const id = setInterval(() => {
      axios
        .get(commentURL)
        .then((res) => {
          setGetComment(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }, WAIT_TIME);
    return () => clearInterval(id);
  }, [getComment]);

  let reverseComment = [];

  getComment.forEach((element) => {
    reverseComment.unshift(element);
  });

  const result = reverseComment.filter((item) => item.pitchId === id);

  //-------------------------------------- nested form control


  const [form, setForm] = useState(false);
  const formControl = () => {
    if (form === false) {
      setForm(true)
    }
    else {
      setForm(false)
    }
  }


  //-------------------------------------- Get Comment Id
  const [getId, setGetId] = useState('');

  //------------------------------ post nested comment data

  const [nestedComment, setNestedComment] = useState([]);

  const handleChangeNestedComment = (event) => {
    setNestedComment(event.target.value);
  };

  const handleSubmitNestedComment = (event) => {
    event.preventDefault();
    const nestcommentUrl = "https://tbc-backend.up.railway.app/nestedComment/create";

    const headers = { "Content-Type": "application/json" };
    const nestedCommentData = {
      commentId: getId,
      commentAuthorName: user.firstName + " " + user.lastName,
      commentAuthorField: user.niche,
      commentAuthorFieldSector: user.currentField,
      commentMsg: nestedComment,
      commentReplyDate: day + '/' + currMonth + '/' + year,
      commentReplyTime: time,
      pitchId: id,
    };

    axios
      .post(nestcommentUrl, nestedCommentData, { headers })
      .then((res) => {
        showAlert(`Comment is Posted`, 'primary', '#info-fill')
        setNestedComment([]);
        setForm(false)
      })
      .catch((err) => {
        showAlert(`Sorry! Comment is Failed to Post, Try Again`, 'warning', '#exclamation-triangle-fill')
        console.log(err);
      });
  };



  //------------------------------ get nested data


  const nestedCommentURL = "https://tbc-backend.up.railway.app/nestedcomment/get";
  const nestedWAIT_TIME = 1000;

  useEffect(() => {
    const id = setInterval(() => {
      axios
        .get(nestedCommentURL)
        .then((res) => {
          setGetNestedComment(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }, nestedWAIT_TIME);
    return () => clearInterval(id);
  }, [getNestComment]);

  let reverseNestedComment = [];

  getNestComment.forEach((element) => {
    reverseNestedComment.unshift(element);
  });

  return (
    <section style={{ backgroundColor: "black" }} className="mb-5 pb-5   ">
      <div className="container my-5 commentborder ">
        <form
          action=""
          className="container text-center"
          onSubmit={handleSubmitComment}
        >
          <div className="text-start d-flex justify-content-center mb-2 text-white fs-5">
            <label htmlFor="comment">Post comments here about above Pitch</label>
          </div>
          <textarea
            type="text"
            className="col-12 col-lg-6 p-2 rounded bg-black text-white border border-white"
            placeholder="write here.."
            rows={5}
            cols="30"
            id="comment"
            value={comment}
            onChange={handleChangeComment}
          />
          <br />
          <button className="btn btn-primary col-lg-6 col-12" type="submit">
            Submit
          </button>
        </form>


        <div className="comments-container col-10 col-lg-6 w-100 w-lg-50 ">

          {commentHeading && <h1 className="text-white mb-5">Comments</h1>}
          {result.map((comment) => {
            return (
              <>
                <ul
                  id="comments-list"
                  className="comments-list"
                  key={comment._id}
                  style={{ marginTop: "0px" }}
                >
                  <li style={{ marginBottom: "0px" }}>
                    <div className="comment-main-level">
                      {/* Avatar */}
                      <div className="comment-avatar">
                        <img
                          src={iconProfilePicture}
                          alt=""
                        />
                      </div>
                      <div className="comment-box col-10 ">
                        <div className="comment-head d-flex">
                          <h6 className="comment-name ">
                            <p >
                              {comment.authorName} | {comment.authorCurrentField} |{" "}
                              {comment.authorNiche}
                            </p>
                          </h6>
                          <div>
                            <div className="d-flex">
                              <span >
                                {comment.commentDate} {comment.commentTime}
                              </span>
                              <div onClick={() => { setGetId(comment._id) }}>
                                <i className="fa fa-reply ps-5" onClick={formControl} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="comment-content mb-5"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {comment.pitchComments}
                        </div>
                      </div>
                    </div>

                    {/* //------------------ Reply comment  */}
                    {comment._id === getId ?
                      <div className={form ? "d-block" : "d-none"}>
                        <form
                          action=""
                          className="container text-end d-flex justify-content-end mb-5"
                          onSubmit={handleSubmitNestedComment}
                        >
                          <textarea
                            type="text"
                            className="col-8 rounded bg-black text-white border border-white me-2 p-2 fs-6"
                            placeholder="write here.."
                            rows={1}
                            cols="50"
                            id="comment"
                            value={nestedComment}
                            onChange={handleChangeNestedComment}
                          />
                          <br />
                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        </form>
                      </div> : null
                    }
                    <ul className="comments-list reply-list pb-4">
                      {reverseNestedComment.filter(item => comment._id === item.commentId).map((nestedComment) => {
                        return (
                          <>
                            <li className="mb-4" key={nestedComment._id}>
                              <div className="comment-avatar">
                                <img
                                  src={iconProfilePicture}
                                  alt=""
                                />
                              </div>
                              <div className="comment-box col-10 ">
                                <div className="comment-head">
                                  <h6 className="comment-name ">
                                    <p href="http://creaticode.com/blog">
                                      {nestedComment.commentAuthorName} | {nestedComment.commentAuthorField}{" "}
                                      | {nestedComment.commentAuthorFieldSector}
                                    </p>
                                  </h6>
                                  <span>{nestedComment.commentReplyDate} {nestedComment.commentReplyTime} </span>
                                </div>
                                <div className="comment-content">
                                  {nestedComment.commentMsg}
                                </div>
                              </div>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </li>
                </ul>
              </>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Comment;
